<template>
<div class="chapter">
<div class="inner_page">
<div class="img_container">
<a id="page_vii"><img alt="image" src="images/f0vii-01.jpg"/>
<p class="fcaption">Napoleon Bonaparte 15 August 1796–5 May 1821.</p>
</a></div><a id="page_vii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_FM01.vue?7954307e